import { Width } from "@twilio-paste/core/style-props";
import { CompositeCalloutProps } from "./compositeCallout";
import { ValueOf } from "./utility";

export const ConfirmationCardVariant = {
  success: "success",
  information: "information",
} as const;
export type ConfirmationCardVariantType = ValueOf<
  typeof ConfirmationCardVariant
>;

export interface ConfirmationCardValue {
  label: string;
  value: string;
  url?: string;
  showExternal?: boolean;
}

export interface ConfirmationCardProps {
  calloutProps?: CompositeCalloutProps;
  details: Record<string, ConfirmationCardValue>;
  id?: string;
  title: string;
  variant?: ConfirmationCardVariantType;
  width?: Width | string;
}
